import React, {Fragment} from 'react';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import Aqp from '../../../../libs/mk-react-aqp';

import {fetchForumCategories, resetForumCategories} from "../../../../creators/forums.categories";
import {
    categoriesObjectByForumId
} from "../../../../selectors/forum-categories";

import CardCategory from "./CardCategory";
import ContentLoader from "react-content-loader"
import {Link} from "react-router-dom";
import _ from 'lodash';
import createLink from "../../../../libs/createLink";
import Title from "../../../components/Title";

let mapping = {
    //TODO : revoir il remplace pour la query avec les bonnes valeurs mais rajoute des & dans l'url
    'owner.profile.gender': 'gender',
};

class ForumChildrens extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            limit: 20,
            page: 1,
            sort: 0,
            "owner.profile.gender": [],
            parentSlug : this.props.match.params.slugParent
        };

        let category = this.props.match.params.slugParent ?
            {category : {slug : this.props.forumSlug, _id : this.props.forumId}} :
            {category : {slug : this.props.forumSlug, _id : this.props.forumId}};
        this.aqp = new Aqp(mapping, {
            blacklist: ['limit', 'page', 'parentSlug'],
            currentLink: this.props.match.params.slug ? createLink("forumCategory", category)  : "",
            filterDefault: this.filter
        });

        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1}
        };

        this.props.fetchForumCategories(this.props.forumId);
    }

    componentWillUnmount() {
        // this.props.resetForumCategories(this.props.categoriesKeysByForumId);
        this.aqp.setCurrentLink("");
    }

    render() {
        let {childrens = []} = this.props.forumCategories;
        // console.log(this.props.forumCategories);
        return !this.props.forumCategoriesInitialized ? (
            <div className="p-16">
                {_.times(10).map((item, index) => (
                    <ContentLoader
                        key={index}
                        height={38}
                        width={800}
                        speed={2}
                        ariaLabel={false}
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <circle cx="22.5" cy="18.29" r="16.5"/>
                        <rect x="50.56" y="18.61" rx="4" ry="4" width="161" height="5"/>
                        <rect x="504.56" y="13.61" rx="4" ry="4" width="65" height="5"/>
                        <rect x="497.56" y="23.61" rx="4" ry="4" width="73" height="5"/>
                        <circle cx="597.35" cy="19.4" r="13.79"/>
                        <rect x="665.56" y="6.61" rx="4" ry="4" width="124" height="5"/>
                        <rect x="667.56" y="17.61" rx="4" ry="4" width="122" height="5"/>
                        <rect x="665.56" y="28.61" rx="4" ry="4" width="125" height="5"/>
                    </ContentLoader>
                ))}
            </div>
        ) : (
            <Fragment>
                <div className={`topline ${this.props.indexForum === 0 ? "row" : ""}`}>
                    {this.props.indexForum === 0 && (
                        <Title className={"title-wrapper"} heading={"heading-1"} display={"display-0"}>
                            <Link to={"/"}>
                                Accueil
                            </Link>
                        </Title>
                    )}
                    {this.props.indexForum === 0 && (<span style={{"padding" : "4px 8px", "fontSize": "14px", "fontWeight": "bold"}}> > </span>)}
                    {this.props.indexForum === 0 && (
                        <Title className={"title-wrapper"} heading={"heading-1"} display={"display-0"}>
                            <Link to={createLink("forum")}>
                                Forum Sexe
                            </Link>
                        </Title>
                    )}
                    {this.props.indexForum === 0 && (
                        <span style={{"padding" : "4px 8px", "fontSize": "14px", "fontWeight": "bold"}}> > </span>
                    )}
                    <Title className={"title-wrapper"} heading={"heading-2"} display={"display-0"}>
                        <Link to={createLink("forumCategory", {category : {slug : this.props.forumSlug, _id : this.props.forumId}})}>
                            {this.props.forumName}
                        </Link>
                    </Title>
                </div>
                {childrens.map((childrens, childrensIndex) => (
                    <CardCategory
                        {...childrens}
                        currentUser={this.props.currentUser}
                        key={childrensIndex}
                        match={this.props.match}
                        breadcrumbs={this.props.breadcrumbs}
                    />
                ))}
            </Fragment>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        currentUser: state.currentUser.data,

        forumCategories: categoriesObjectByForumId(state, props).data,
        // categoriesKeysByForumId: categoriesKeysByForumId(state, props),
        forumCategoriesLoading: categoriesObjectByForumId(state, props).loading,
        forumCategoriesInitialized: categoriesObjectByForumId(state, props).initialized,
        forumCategoriesTotal: categoriesObjectByForumId(state, props).total,

        breadcrumbs : state.forumBreadcrumbs.data
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchForumCategories,
    resetForumCategories,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForumChildrens);
